import styled from 'styled-components';

import { Box } from '../../../../common/ui/Box';

export const OfferAccordion = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
`;
